module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Smoke and Mirrors")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/additional.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "books-by-head"
  }, [_c('em', [_vm._v("Recent Titles by Casey Daniels")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("The Pepper Martin Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("DON OF THE DEAD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("THE CHICK AND THE DEAD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("TOMBS OF ENDEARMENT")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("NIGHT OF THE LOVING DEAD")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("DEAD MAN TALKING")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("TOMB WITH A VIEW")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("A HARD DAY’S FRIGHT")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("WILD WILD DEATH")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_vm._v("SUPERNATURAL BORN KILLERS")]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("GRAVEYARD SHIFT*")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_c('em', [_vm._v("The Miss Barnum Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "books-by-text-space-after"
  }, [_vm._v("SMOKE AND MIRRORS*")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "books-by-text"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('em', [_vm._v("* available from Severn House")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11794cbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/alsoby.vue
// module id = 63
// module chunks = 0